export default "__VITE_ASSET__197aad1e__"